import axios from 'axios'

import { Loading, Message, Notification } from 'element-ui'
const STATUS = {
  SUCESS_CODE: 10000, // "请求成功"
  E_LOGINERROR: '20001', // "用户名或密码错误"
  E_SELECTRROR: '20023', // "查询失败"
  E_NOTFOUND: '30001', // "未知信息"
  E_DEVICE_CACHE: '20004', // "设备缓存增加失败"
  E_REQUESTERROR: '20004', // "修改失败"
  E_YWYDATAERROR: '20019', // "添加失败"
  E_EDITERROR: '20024', // "删除失败"
  E_IMGNOTFOUND: '20002', // "图片不能为空"
  E_IMGFORMATERROR: '20003', // "图片格式错误"
  E_BADREQUEST: '20400', // "请求处理异常，请稍后再试"
  E_DUPLICATESITENAME: '20005', // "站点名称重复"
  E_DEVICE_ALREDAY_EXIST: '20006', // "设备已存在"
  E_DEVICE_ISDELETE: '20007', // "设备已被删除"
  E_DEVICE_ISNOTREG: '20010', // "设备没有被注册"
  E_DEVICE_ISBINDING: '20008', // "设备已被绑定"
  E_DEVICE_ISNOTBINDING: '20011', // "设备未被绑定"
  E_DEVICE_ISNOTEXIST: '20009', // "设备不存在"
  E_INTERNAL_SERVER_ERROR: '20012', // "短信请求失败"
  E_NOT_PHONE: '20018', // "没有这个用户"
  E_MESSAGE_SERVER_LIMIT: '20014', // "您今日短信发送量已达上限"
  E_PASSWORD: '20013', //"密码错误"
  E_DeviceReg: '90001' //"添加设备信息成功, 但到运营商平台注册失败，请到注册设备设备菜单查询详情"
  /*E_400("400", "请求处理异常，请稍后再试"),
	E_500("500", "请求方式有误,请检查 GET/POST"),
	E_501("501", "请求路径不存在"),
	E_502("502", "权限不足"),
	E_10008("10008", "角色删除失败,尚有用户属于此角色"),
	E_10009("10009", "账户已存在"),
	E_20011("20011", "登录已过期,请重新登录"),
	E_90003("90003", "缺少必填参数")*/
}

const preAxios = function(method, args) {
  const apiUrl = args[0]
  args[0] = process.env.API_HOST + args[0]
  let p = new Promise((resolve, reject) => {
    axios[method](...args)
      .then(
        res => {
          if (
            res.data.status == STATUS.SUCESS_CODE ||
            res.data.status == '10000' ||
            res.config.responseType == 'blob'
          ) {
            resolve(res)
          } else {
            Message({
              message: res.data.message,
              type: 'warning',
              duration: 3000
            })
            if (['auth/token/login'].some(url => url == apiUrl)) {
              resolve(res)
            } else {
              reject(res)
            }
          }
        } //res
      ) //axios[method](...args).then(
      .catch(
        error => {
          console.debug(error)
          reject(error)
          if (
            error.response.status != 401 &&
            error.response.status != 500 &&
            error.response.status != 403
          ) {
            Message({
              message: '系统错误，请稍后重试！（' + error + ')',
              type: 'error',
              duration: 3000
            })
          }
        } //error
      )
  })
  return p
}

export const dataUrl = res => res.data.data

export const axiosget = function() {
  return preAxios.call(this, 'get', arguments)
}

export const axiospost = function() {
  return preAxios.call(this, 'post', arguments)
}

export const axiosput = function() {
  return preAxios.call(this, 'put', arguments)
}

export const axiosdelete = function() {
  return preAxios.call(this, 'delete', arguments)
}



// WEBPACK FOOTER //
// ./src/utils/axiosMethods.js